// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"f1109fa4","254":"f466edaa","314":"ac46edb7","426":"57491e67","605":"aa0d7d25"}[chunkId] + ".chunk.css";
};